<app-form (submit)="updateInfo()" data-modal-backdrop-static>
    <div class="card">
        <div class="card-header details-modal-header">
            <h3 class="card-header-title">
                <app-connection-image
                        [connectionType]="data.entity.connection.info.connectionType"></app-connection-image>
                Meter information
            </h3>
            <div class="details-modal-close-zone">
                <button type="button" class="btn-close details-modal-close" data-bs-dismiss="modal"
                        aria-label="Close"></button>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-md-6">
                    <app-form-field label="Label">
                        <input [(ngModel)]="details.label" type="text" class="form-control">
                    </app-form-field>
                </div>
                <div *ngIf="!isPrimaryMeter" class="col-12 col-md-6">
                    <app-form-field label="Display options" [renderOptional]="false">
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="meterVisible" [ngModel]="visible"
                                   (ngModelChange)="onVisibleChange($event)">
                            <label class="form-check-label" for="meterVisible">Visible</label>
                        </div>
                        <div class="form-check mb-2" *ngIf="!isCoolingMeter">
                            <input class="form-check-input" type="checkbox" id="meterBpm" [ngModel]="bpm"
                                   (ngModelChange)="onBpmChange($event)"
                                   [disabled]="isResidualMeter || isSourceBpm || isSourceChargePoint">
                            <label class="form-check-label" for="meterBpm">Gross production meter (BPM)</label>
                        </div>
                        <div class="form-check" *ngIf="!isCoolingMeter">
                            <input class="form-check-input" type="checkbox" id="meterChargePoint" [ngModel]="chargePoint"
                                   (ngModelChange)="onChargePointChange($event)"
                                   [disabled]="isResidualMeter || isSourceChargePoint || isSourceBpm">
                            <label class="form-check-label" for="meterChargePoint">Charge point</label>
                        </div>
                        <small *ngIf="isResidualMeter" class="text-muted">The calculated remainder can only be shown or hidden.</small>
                        <small *ngIf="isCoolingMeter">Cooling belongs to the heat meter on this connection.</small>
                        <small *ngIf="isSourceBpm || isSourceChargePoint" class="text-muted">This classification is managed by the active data source.</small>
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Source meter number" [renderOptional]="false">
                        <input [ngModel]="sourceMeterNumber" type="text" class="form-control notranslate" disabled>
                        <small class="text-muted">Managed by the source system and cannot be edited.</small>
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Additional meter numbers" [renderOptional]="false">
                        <ng-container *ngFor="let m of details.meterNumbers; let i = index; trackBy: trackByIndex">
                            <input [(ngModel)]="details.meterNumbers[i]" type="text" class="form-control">
                        </ng-container>
                    </app-form-field>
                </div>
                <div *ngIf="!isPrimaryMeter" class="col-12 col-md-6">
                    <app-form-field label="Area">
                        <input [(ngModel)]="details.area" type="number" class="form-control">
                    </app-form-field>
                </div>
                <ng-container *ngFor="let metadataField of metadataFields; trackBy: trackByIndex">
                    <div *ngIf="!isPrimaryMeter" class="col-12 col-md-6">
                        <app-form-field [label]="metadataField.label">
                            <div class="input-group">
                                <input [ngModel]="metadataForm[metadataField.field].value"
                                       (ngModelChange)="metadataForm[metadataField.field].value = $event"
                                       type="text" class="form-control"
                                       [disabled]="isSourceMetadataField(metadataField.field)">
                                <span *ngIf="isSourceMetadataField(metadataField.field)"
                                      class="input-group-text text-muted"
                                      [title]="sourceMetadataHelp"
                                      [attr.aria-label]="sourceMetadataHelp">
                                    <i class="bi bi-info-circle" aria-hidden="true"></i>
                                </span>
                            </div>
                        </app-form-field>
                    </div>
                </ng-container>
                <div *ngIf="!isPrimaryMeter && appContext.isAdminOrIntermediary()" class="col-12 col-md-6">
                    <app-form-field label="Categories">
                        <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
                            <ng-container *ngIf="details.tags?.length">
                                <ng-container *ngFor="let tag of details.tags; let i = index; trackBy: trackByIndex">
                                    <ng-container *ngIf="isDetailCategoryTag(tag)">
                                        <button type="button" class="btn btn-info btn-sm d-inline-flex align-items-center gap-1 flex-shrink-0">
                                            <span [class.notranslate]="tag.category === 'custom'">
                                                {{ tag.category === 'custom' ? tag.customType : (tag.category | sentenceCase) }}
                                            </span>:<span class="notranslate">{{ tag.value }}</span>
                                            <span class="btn-close btn-close-white p-0 ms-1" aria-label="Remove" (click)="removeTag(details.tags, i)"></span>
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <button *ngIf="newTags.length === 0" type="button"
                                    class="btn btn-outline-info btn-sm flex-shrink-0 ms-1" (click)="addTag()">
                                Add category
                            </button>
                        </div>
                        <div *ngFor="let tag of newTags; let i = index"
                             class="border rounded p-3 mb-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <strong>New category</strong>
                                <button type="button" class="btn-close ms-2" aria-label="Cancel adding category"
                                        (click)="removeTag(newTags, i)"></button>
                            </div>
                            <label class="form-label mt-2">Category</label>
                            <app-select [(ngModel)]="tag.category" [options]="categories" (ngModelChange)="onCategoryChange(tag)" placeholder="Select category" required>
                            </app-select>
                            <div *ngIf="tag.category === 'custom'" class="mt-2">
                                <label class="form-label">Custom category</label>
                                <input [(ngModel)]="tag.customType" type="text" class="form-control" placeholder="Custom category" required>
                            </div>
                            <div class="mt-2">
                                <label class="form-label">Value</label>
                                <input [(ngModel)]="tag.value" type="text" class="form-control" placeholder="Value" required>
                            </div>
                            <div class="d-flex justify-content-end mt-3">
                                <button type="button" class="btn btn-info btn-sm"
                                        [disabled]="!isTagValid(tag)" (click)="confirmTag(tag, i)">
                                    <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Add category
                                </button>
                            </div>
                        </div>
                    </app-form-field>
                </div>
            </div>
        </div>

        <div class="card-footer">
            <div class="d-flex justify-content-between">
                <a class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                <button type="submit" class="btn btn-primary" [disabled]="newTags.length > 0">
                    Save changes
                </button>
            </div>
        </div>
    </div>
</app-form>
